import React from "react";
import PropTypes from "prop-types";
import { getComponent, getTrackingProps } from "./helpers";

const CreationForm = (props) => {
  const drawerType = props.drawer.sliceType;
  const Form = getComponent(drawerType);
  const trackingProps = getTrackingProps(drawerType);
  return Form ? <Form {...props} {...trackingProps} /> : <div>💅💅💅️</div>;
};

CreationForm.propTypes = {
  drawer: PropTypes.shape({
    sliceType: PropTypes.string.isRequired,
  }).isRequired,
};

export default CreationForm;
